import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { InstanceTypesPage } from '@/features/admin/instance-types/instance-type-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Catalogue des types d'instance (porting README #49). */
export const Route = createFileRoute('/$tenant/resources/instance-types/')({ component: InstanceTypesRoute });

function InstanceTypesRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="instanceTypes"
      crumbs={[{ label: t('nav.items.instanceTypes') }]}
    >
      <InstanceTypesPage tenantId={tenant} />
    </ConsoleShell>
  );
}
